import type { AnswerValue, Answers, FileRef, FormDefinition } from '../../lib/types';
import { fileUrl, formatBytes, formatDate } from '../../lib/utils';
import { isEmptyAnswer } from '../../lib/validation';

function AnswerContent({ value, type }: { value: AnswerValue | undefined; type: string }) {
  if (isEmptyAnswer(value)) return <p className="muted no-answer">No answer</p>;

  if (type === 'file_upload') {
    const files = value as FileRef[];
    return (
      <ul className="file-list">
        {files.map((f) => (
          <li key={f.id}>
            {f.contentType.startsWith('image/') ? (
              <a href={fileUrl(f.id)} target="_blank" rel="noreferrer">
                <img src={fileUrl(f.id)} alt={f.name} className="file-thumb large" />
              </a>
            ) : (
              <span className="file-icon">PDF</span>
            )}
            <a href={fileUrl(f.id)} target="_blank" rel="noreferrer" className="file-name">
              {f.name}
            </a>
            <span className="muted small">{formatBytes(f.size)}</span>
          </li>
        ))}
      </ul>
    );
  }
  if (Array.isArray(value)) {
    return (
      <ul className="answer-list">
        {(value as string[]).map((v) => (
          <li key={v}>{v}</li>
        ))}
      </ul>
    );
  }
  if (type === 'date' && typeof value === 'string')
    return <p className="answer-text">{formatDate(value)}</p>;
  return <p className="answer-text">{String(value)}</p>;
}

/** Read-only, print-friendly view of a client's answers. */
export function AnswersView({ form, answers }: { form: FormDefinition; answers: Answers }) {
  let n = 0;
  return (
    <div className="answers">
      {form.sections.map((s) => (
        <section key={s.id} className="card answers-section">
          <h2>{s.title}</h2>
          {s.questions.map((q) => {
            n += 1;
            return (
              <div key={q.id} className="answer">
                <h3>
                  <span className="question-number">{n}</span> {q.label}
                </h3>
                {q.quote && <blockquote className="quote small">{q.quote}</blockquote>}
                <AnswerContent value={answers[q.id]} type={q.type} />
              </div>
            );
          })}
        </section>
      ))}
    </div>
  );
}
